<div class="tooltip-content">
  {{tooltipContent}}
</div>
